// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import API from '../utils/api';
// import CourseCard from '../components/CourseCard';

// const stats = [
//   { label: 'Students Enrolled', value: '500+' },
//   { label: 'Courses Available', value: '20+' },
//   { label: 'Certificates Issued', value: '300+' },
//   { label: 'Completion Rate', value: '94%' },
// ];

// const steps = [
//   { icon: '🔍', title: 'Browse Courses', desc: 'Explore our curated tech & programming courses.' },
//   { icon: '📝', title: 'Apply & Pay', desc: 'Fill the form and pay via GPay. Simple & fast.' },
//   { icon: '✅', title: 'Get Approved', desc: 'Admin verifies payment and assigns your batch date.' },
//   { icon: '🏆', title: 'Earn Certificate', desc: 'Complete the course and download your certificate.' },
// ];

// const Home = () => {
//   const [courses, setCourses] = useState([]);

//   useEffect(() => {
//     API.get('/courses').then(res => setCourses(res.data.slice(0, 3))).catch(() => {});
//   }, []);

//   return (
//     <div>
//       {/* Hero */}
//       <section style={{
//         minHeight: '100vh', display: 'flex', alignItems: 'center',
//         background: 'radial-gradient(ellipse at 60% 40%, #2d1060 0%, #0f0a1e 60%)',
//         position: 'relative', overflow: 'hidden', padding: '100px 0 60px',
//       }}>
//         <div style={{ position: 'absolute', top: '20%', right: '10%', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, #7c3aed22, transparent)', filter: 'blur(40px)', pointerEvents: 'none' }} />
//         <div style={{ position: 'absolute', bottom: '10%', left: '5%', width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, #a855f722, transparent)', filter: 'blur(60px)', pointerEvents: 'none' }} />

//         <div className="container" style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
//           <div style={{ display: 'inline-block', background: '#2d1f5e', border: '1px solid #7c3aed', borderRadius: 999, padding: '6px 20px', marginBottom: 32, fontSize: 14, color: '#c084fc' }}>
//             🚀 Tamil Nadu's Rising Ed-Tech Platform
//           </div>
//           <h1 style={{ fontSize: 'clamp(38px, 7vw, 78px)', fontWeight: 800, lineHeight: 1.1, marginBottom: 24 }}>
//             Learn. Grow.<br />
//             <span style={{ background: 'linear-gradient(135deg, #a855f7, #7c3aed)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Get Certified.</span>
//           </h1>
//           <p style={{ color: '#94a3b8', fontSize: 'clamp(16px, 2vw, 20px)', maxWidth: 580, margin: '0 auto 40px', lineHeight: 1.7 }}>
//             Industry-focused tech courses with real mentors, live classes, and verifiable certificates — all in one place.
//           </p>
//           <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
//             <Link to="/courses" className="btn btn-primary" style={{ fontSize: 16, padding: '14px 36px' }}>Explore Courses</Link>
//             <Link to="/register" className="btn btn-outline" style={{ fontSize: 16, padding: '14px 36px' }}>Join Free</Link>
//           </div>

//           {/* Stats */}
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 24, marginTop: 80, maxWidth: 700, margin: '80px auto 0' }}>
//             {stats.map((s, i) => (
//               <div key={i} style={{ textAlign: 'center' }}>
//                 <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 36, color: '#a855f7' }}>{s.value}</div>
//                 <div style={{ color: '#64748b', fontSize: 13, marginTop: 4 }}>{s.label}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* How It Works */}
//       <section style={{ padding: '100px 0', background: '#0a0618' }}>
//         <div className="container">
//           <div style={{ textAlign: 'center', marginBottom: 60 }}>
//             <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', marginBottom: 12 }}>How It Works</h2>
//             <p style={{ color: '#94a3b8', fontSize: 17 }}>Simple 4-step process to get certified</p>
//           </div>
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 28 }}>
//             {steps.map((s, i) => (
//               <div key={i} className="card" style={{ textAlign: 'center', position: 'relative' }}>
//                 <div style={{ position: 'absolute', top: -16, left: '50%', transform: 'translateX(-50%)', background: '#7c3aed', borderRadius: '50%', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Syne', fontWeight: 800, fontSize: 14 }}>{i + 1}</div>
//                 <div style={{ fontSize: 42, marginBottom: 16, marginTop: 12 }}>{s.icon}</div>
//                 <h3 style={{ fontSize: 18, marginBottom: 10 }}>{s.title}</h3>
//                 <p style={{ color: '#94a3b8', fontSize: 14, lineHeight: 1.6 }}>{s.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Featured Courses */}
//       <section style={{ padding: '100px 0' }}>
//         <div className="container">
//           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 48, flexWrap: 'wrap', gap: 16 }}>
//             <div>
//               <h2 style={{ fontSize: 'clamp(28px, 4vw, 40px)', marginBottom: 8 }}>Featured Courses</h2>
//               <p style={{ color: '#94a3b8' }}>Handpicked programs to boost your career</p>
//             </div>
//             <Link to="/courses" className="btn btn-outline">View All Courses →</Link>
//           </div>
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 28 }}>
//             {courses.map(c => <CourseCard key={c._id} course={c} />)}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section style={{ padding: '80px 0' }}>
//         <div className="container">
//           <div style={{ background: 'linear-gradient(135deg, #4c1d95, #2d1060)', borderRadius: 24, padding: 'clamp(40px, 5vw, 80px)', textAlign: 'center', border: '1px solid #7c3aed', position: 'relative', overflow: 'hidden' }}>
//             <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', marginBottom: 16 }}>Ready to Start Your Journey?</h2>
//             <p style={{ color: '#c4b5fd', fontSize: 17, marginBottom: 36, maxWidth: 500, margin: '0 auto 36px' }}>
//               Join hundreds of students who are learning, growing, and getting certified with ThiranX.
//             </p>
//             <Link to="/register" className="btn btn-primary" style={{ fontSize: 16, padding: '14px 40px', background: '#fff', color: '#7c3aed' }}>
//               Start Learning Today 🚀
//             </Link>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Home;


// // Home.jsx
import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import API from '../utils/api';
import FeaturedCoursesSection from '../components/FeaturedCoursesSection';
import AnnouncementBanner from '../components/AnnouncementBanner';
import { getCachedCourses, setCachedCourses } from '../utils/courseCache';
import Seo, { SITE_URL } from '../components/Seo';

const ORG_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'EducationalOrganization',
  name: 'ThiranX',
  url: SITE_URL,
  logo: `${SITE_URL}/favicon-512.png`,
  description: 'ThiranX is a premium online course certification platform offering industry-focused courses, internships, and micro-internships with verified certificates.',
  address: { '@type': 'PostalAddress', addressRegion: 'Tamil Nadu', addressCountry: 'IN' },
  contactPoint: { '@type': 'ContactPoint', telephone: '+91-6381253611', contactType: 'customer support', email: 'support@thiranx.in' },
  sameAs: [
    'https://www.instagram.com/thiranx_2026?igsh=Y3Q0dG4ycmxpc2x5',
    'https://www.linkedin.com/company/thiranx/',
  ],
};

/* ─── PALETTE ─────────────────────────────────────────────── */
const V1 = '#7F00FF';
const V2 = '#B163FF';
const V3 = '#51158C';
const V4 = '#2B0057';

/* ─── DATA ────────────────────────────────────────────────── */
const stats = [
  { label: 'Launch Year', value: '2026' },
  { label: 'Tech Courses', value: '10+' },
  { label: 'Expert Mentors', value: '15+' },
  { label: 'Govt Recognised', value: '100%' },
];

const steps = [
  {
    num: '01', title: 'Browse Courses',
    desc: 'Explore curated tech & programming courses built for real-world skills.',
    img: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=600&q=80',
  },
  {
    num: '02', title: 'Apply & Pay',
    desc: 'Fill the application and complete payment via GPay — simple and instant.',
    img: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&q=80',
  },
  {
    num: '03', title: 'Get Approved',
    desc: 'Admin verifies your payment, assigns your batch, and notifies you right away.',
    img: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&q=80',
  },
  {
    num: '04', title: 'Earn Certificate',
    desc: 'Complete the course and download your verifiable digital certificate.',
    img: 'https://images.unsplash.com/photo-1523289333742-be1143f6b766?w=600&q=80',
  },
];

const features = [
  { title: 'Expert Mentors', desc: 'Industry professionals who work in the field — not just teaching slides.', img: 'https://images.unsplash.com/photo-1544717305-2782549b5136?w=500&q=80' },
  { title: 'Live Classes', desc: 'Real-time interactive sessions with Q&A, not pre-recorded videos.', img: 'https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?w=500&q=80' },
  { title: 'Verified Certs', desc: 'Each certificate has a unique ID employers can verify online instantly.', img: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=500&q=80' },
  { title: 'Modern Curriculum', desc: 'Updated continuously with the latest industry trends and technologies.', img: 'https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=500&q=80' },
  { title: 'Tamil Medium', desc: 'Learn complex tech concepts in Tamil for deeper understanding.', img: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=500&q=80' },
  { title: 'Affordable Fees', desc: 'World-class education at prices accessible to every student in Tamil Nadu.', img: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=500&q=80' },
];

const testimonials = [
  { name: 'Aravind Kumar', role: 'Full-Stack Developer', batch: '2024', text: 'ThiranX gave me the real skills I needed. The mentors actually care about your growth — not just getting through slides.', img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80' },
  { name: 'Priya Lakshmi', role: 'UI/UX Designer', batch: '2024', text: 'Best decision I made after college. The certificate helped me land my first freelance client within two weeks.', img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80' },
  { name: 'Suresh Balaji', role: 'Backend Engineer', batch: '2023', text: 'Intensive, structured, and very practical. Everything I wished my college degree had been. Worth every rupee.', img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=120&q=80' },
  { name: 'Divya Nair', role: 'Data Analyst', batch: '2024', text: 'The Tamil medium classes were a game changer for me. I could grasp concepts so much faster in my own language.', img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=120&q=80' },
  { name: 'Kiran Raj', role: 'Cloud Engineer', batch: '2023', text: 'Got placed at a top MNC 3 weeks after completing the course. The placement support team is absolutely stellar.', img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=80' },
];


const techStack = ['React', 'Node.js', 'Python', 'MongoDB', 'TypeScript', 'Next.js', 'Docker', 'AWS', 'Figma', 'PostgreSQL', 'GraphQL', 'Git'];

/* ─── COUNT-UP HOOK ───────────────────────────────────────── */
const useCountUp = (target, duration = 1600) => {
  const [val, setVal] = useState('');
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const num = parseInt(target);
    if (isNaN(num)) { setVal(target); return; }
    const suffix = target.replace(String(num), '');
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting || started.current) return;
      started.current = true;
      obs.disconnect();
      let cur = 0;
      const step = num / (duration / 16);
      const t = setInterval(() => {
        cur = Math.min(cur + step, num);
        setVal(Math.floor(cur) + suffix);
        if (cur >= num) clearInterval(t);
      }, 16);
    }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [target, duration]);
  return { val: val || target, ref };
};

const StatItem = ({ value, label, last }) => {
  const { val, ref } = useCountUp(value);
  return (
    <div ref={ref} style={{ textAlign: 'center', padding: '44px 24px', borderRight: last ? 'none' : '1px solid var(--border)' }}>
      <div style={{
        fontFamily: "'Inter',sans-serif",
        fontWeight: 800, fontSize: 'clamp(38px,4.5vw,58px)',
        color: 'var(--text)', lineHeight: 1, letterSpacing: '-0.03em',
      }}>{val}</div>
      <div style={{ color: 'var(--muted)', fontSize: 12, marginTop: 10, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase' }}>{label}</div>
    </div>
  );
};

/* ─── CIRCUIT BG ──────────────────────────────────────────── */
const CircuitBg = () => (
  <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 0, opacity: 0.07 }}>
    <svg viewBox="0 0 1400 800" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" style={{ width: '100%', height: '100%' }}>
      <g stroke={V2} strokeWidth="0.9" fill="none">
        <line x1="0" y1="160" x2="320" y2="160" /><line x1="380" y1="160" x2="680" y2="160" />
        <line x1="980" y1="120" x2="1400" y2="120" />
        <line x1="0" y1="420" x2="210" y2="420" /><line x1="570" y1="420" x2="880" y2="420" />
        <line x1="0" y1="660" x2="460" y2="660" /><line x1="810" y1="660" x2="1400" y2="660" />
        <line x1="320" y1="0" x2="320" y2="260" /><line x1="680" y1="120" x2="680" y2="260" />
        <line x1="880" y1="340" x2="880" y2="500" /><line x1="210" y1="360" x2="210" y2="500" />
        <circle cx="320" cy="160" r="5" fill={V1} opacity="0.9" />
        <circle cx="680" cy="160" r="4" fill={V2} opacity="0.9" />
        <circle cx="210" cy="420" r="4" fill={V2} opacity="0.9" />
        <circle cx="570" cy="420" r="5" fill={V1} opacity="0.9" />
        <circle cx="460" cy="660" r="5" fill={V1} opacity="0.9" />
        <circle cx="320" cy="260" r="7" stroke={V2} strokeWidth="1.5" fill="none" />
        <circle cx="880" cy="340" r="7" stroke={V1} strokeWidth="1.5" fill="none" />
      </g>
    </svg>
  </div>
);

/* ─── MARQUEE ─────────────────────────────────────────────── */
const Marquee = () => {
  const items = [...techStack, ...techStack];
  return (
    <div style={{ overflow: 'hidden', padding: '20px 0', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)', background: 'var(--bg2)' }}>
      <div style={{ display: 'flex', gap: 48, width: 'max-content', animation: 'marqueeScroll 20s linear infinite' }}>
        {items.map((t, i) => (
          <span key={i} style={{ color: 'var(--muted)', fontWeight: 700, fontSize: 13, letterSpacing: '0.06em', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: i % 2 === 0 ? V1 : V2, display: 'inline-block', flexShrink: 0 }} />
            {t}
          </span>
        ))}
      </div>
    </div>
  );
};

/* ─── MAIN ────────────────────────────────────────────────── */
const TESTI_DELAY = 4000;

const Home = () => {
  const [apiCourses, setApiCourses] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(true);
  const [heroIn, setHeroIn] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [testiIdx, setTestiIdx] = useState(0);
  const testiPausedRef = useRef(false);

  // eslint-disable-next-line no-unused-vars
  const prevTesti = () => setTestiIdx(i => (i - 1 + testimonials.length) % testimonials.length);
  // eslint-disable-next-line no-unused-vars
  const nextTesti = () => setTestiIdx(i => (i + 1) % testimonials.length);

  useEffect(() => {
    // Cache-first strategy for instant results on navigation
    const cached = getCachedCourses('home_courses');
    if (cached) {
      setApiCourses(cached);
      setCoursesLoading(false);
    }
    API.get('/courses').then(r => {
      setApiCourses(r.data);
      setCachedCourses('home_courses', r.data);
    }).catch(() => { }).finally(() => setCoursesLoading(false));
    setTimeout(() => setHeroIn(true), 80);
  }, []);

  /* Stable testimonial interval — never restarts */
  useEffect(() => {
    const timer = setInterval(() => {
      if (!testiPausedRef.current) {
        setTestiIdx(i => (i + 1) % testimonials.length);
      }
    }, TESTI_DELAY);
    return () => clearInterval(timer);
  }, []); // run once, forever

  return (
    <div style={{ background: 'var(--bg)', color: 'var(--text)' }}>
      <Seo
        title="ThiranX | Learn. Grow. Certify."
        rawTitle
        description="ThiranX is a premium online course certification platform. Boost your career with interactive learning, industry-recognized certificates, real internships, and ₹99 micro-internships."
        path="/"
        schema={ORG_SCHEMA}
      />

      {/* ══ HERO ════════════════════════════════════════════ */}
      <section style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        position: 'relative', overflow: 'hidden',
        padding: '120px 0 90px',
        background: 'var(--bg)',
      }}>
        <CircuitBg />
        {/* One clean subtle accent — bottom right */}
        <div style={{ position: 'absolute', bottom: '0', right: '0', width: 420, height: 420, borderRadius: '50%', background: `radial-gradient(circle, var(--hero-orb) 0%, transparent 70%)`, pointerEvents: 'none' }} />

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <AnnouncementBanner />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'center' }} className="hero-grid">

            {/* LEFT */}
            <div>
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                border: `1px solid var(--badge-pill-border)`, borderRadius: 999,
                padding: '6px 18px', marginBottom: 36,
                fontSize: 11.5, fontWeight: 800, color: 'var(--badge-pill-text)',
                letterSpacing: '0.08em', textTransform: 'uppercase',
                background: 'var(--badge-pill-bg)',
                opacity: heroIn ? 1 : 0,
                transform: heroIn ? 'translateY(0)' : 'translateY(16px)',
                transition: 'all 0.55s ease',
              }}>
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: V2, display: 'inline-block', animation: 'pulseGlow 2s ease-in-out infinite' }} />
                Tamil Nadu's Rising Ed-Tech Platform
              </div>

              <h1 style={{
                fontSize: 'clamp(44px,7vw,88px)',
                fontWeight: 700, lineHeight: 1.12,
                letterSpacing: '-0.03em', marginBottom: 24,
                fontFamily: "'Inter',sans-serif",
                opacity: heroIn ? 1 : 0,
                transform: heroIn ? 'translateY(0)' : 'translateY(24px)',
                transition: 'all 0.6s ease 0.1s',
              }}>
                Skills That<br />
                Get You{' '}
                <span style={{
                  background: `linear-gradient(135deg,${V1},${V2})`,
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
                }}>Hired.</span>
              </h1>

              <p style={{
                color: 'var(--text-2)', fontSize: 'clamp(15px,1.8vw,18px)',
                maxWidth: 480, lineHeight: 1.8, marginBottom: 44,
                opacity: heroIn ? 1 : 0,
                transform: heroIn ? 'translateY(0)' : 'translateY(16px)',
                transition: 'all 0.6s ease 0.2s',
              }}>
                Industry-focused tech courses with real mentors, live classes, and verifiable certificates — built for Tamil Nadu's next generation.
              </p>

              <div style={{
                display: 'flex', gap: 12, flexWrap: 'wrap',
                opacity: heroIn ? 1 : 0,
                transform: heroIn ? 'translateY(0)' : 'translateY(16px)',
                transition: 'all 0.6s ease 0.3s',
              }}>
                <Link to="/courses" className="btn btn-primary" style={{ fontSize: 15, padding: '14px 36px' }}>Explore Courses</Link>
                <Link to="/register" className="btn btn-ghost" style={{ fontSize: 15, padding: '14px 32px' }}>Join Free →</Link>
              </div>

              {/* Social proof */}
              <div style={{
                display: 'flex', alignItems: 'center', gap: 14, marginTop: 40,
                opacity: heroIn ? 1 : 0,                 transition: 'all 0.6s ease 0.42s',
              }}>
                <div style={{ display: 'flex' }}>
                  {['A', 'M', 'J', 'S'].map((initial, i) => (
                    <div key={i} style={{
                      width: 36, height: 36, borderRadius: '50%', overflow: 'hidden',
                      border: '2.5px solid var(--bg)', marginLeft: i ? -10 : 0,
                      boxShadow: `0 0 0 1px ${V1}44`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: i % 2 === 0 ? V1 : V2,
                      color: '#fff', fontSize: 13, fontWeight: 800,
                    }} aria-hidden="true">
                      {initial}
                    </div>
                  ))}
                </div>
                <p style={{ color: 'var(--muted)', fontSize: 13.5, fontWeight: 500 }}>
                  <strong style={{ color: 'var(--text)', fontWeight: 800 }}>Join our first batch</strong> across Tamil Nadu
                </p>
              </div>
            </div>

            {/* RIGHT: hero image */}
            <div style={{
              position: 'relative',
              opacity: heroIn ? 1 : 0,
              transform: heroIn ? 'translateX(0)' : 'translateX(32px)',
              transition: 'all 0.7s ease 0.45s',
            }} className="hero-img-col">
              <div style={{
                borderRadius: 24, overflow: 'hidden',
                clipPath: 'polygon(0 0, 100% 0, 100% 88%, 88% 100%, 0 100%)',
                aspectRatio: '4/5', maxHeight: 520,
                boxShadow: '0 32px 80px rgba(0,0,0,0.5)',
              }}>
                <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=900&q=80" alt="Students" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>

              {/* Floating cert card */}
              <div style={{
                position: 'absolute', bottom: '14%', left: '-14%',
                background: 'var(--bg2)', border: '1px solid var(--border-strong)',
                borderRadius: 16, padding: '16px 18px',
                boxShadow: '0 16px 48px rgba(0,0,0,0.4)',
                animation: 'floatY 6s ease-in-out infinite',
                minWidth: 200,
              }}>
                <div style={{ fontSize: 11, color: 'var(--muted)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Organization Status</div>
                <div style={{ fontWeight: 800, fontSize: 14, color: 'var(--text)', marginBottom: 4 }}>MSME Registered</div>
                <div style={{ fontSize: 11, color: V2, fontWeight: 700 }}>Govt. of India Certified</div>
                <div style={{ marginTop: 10, height: 4, borderRadius: 99, background: 'var(--bg3)' }}>
                  <div style={{ width: '100%', height: '100%', borderRadius: 99, background: `linear-gradient(90deg,${V1},${V2})` }} />
                </div>
              </div>

              {/* Floating stat card */}
              <div style={{
                position: 'absolute', top: '8%', right: '-10%',
                background: 'var(--bg2)', border: '1px solid var(--border-strong)',
                borderRadius: 16, padding: '14px 18px',
                boxShadow: '0 12px 40px rgba(0,0,0,0.35)',
                animation: 'floatY 8s ease-in-out infinite 2s',
              }}>
                <div style={{ fontSize: 11, color: 'var(--muted)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>Established</div>
                <div style={{ fontFamily: "'Inter',sans-serif", fontWeight: 900, fontSize: 34, color: 'var(--text)', lineHeight: 1 }}>2026</div>
                <div style={{ color: '#0dba79', fontSize: 12, fontWeight: 700, marginTop: 4 }}>✓ Newly Launched</div>
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* ══ MARQUEE ═════════════════════════════════════════ */}
      <Marquee />

      {/* ══ ₹99 MICRO-INTERNSHIP POSTER ═════════════════════ */}
      <section style={{ padding: '70px 0', background: 'var(--bg)', position: 'relative', overflow: 'hidden' }}>
        <div className="container">
          <div className="poster99-card" style={{
            background: `linear-gradient(135deg,${V4} 0%,${V3} 45%,${V1} 100%)`,
          }}>
            <CircuitBg />
            <div className="poster99-glow poster99-glow-1" />
            <div className="poster99-glow poster99-glow-2" />
            <div className="poster99-shine" />

            <div className="poster99-tag">🔥 LIMITED TIME</div>

            <div className="poster99-content">
              <div className="section-label" style={{ background: 'rgba(255,255,255,0.12)', borderColor: 'rgba(255,255,255,0.2)', color: '#fff' }}>MICRO-INTERNSHIP PROGRAM</div>
              <h2 className="poster99-title">
                Real Micro-Internship.<br />Real Certificate.<br />Just <span className="poster99-price-inline">₹99</span>.
              </h2>
              <p className="poster99-desc">
                Frontend, Backend, UI/UX, Data Science &amp; more — build real projects, get mentored, and walk away with a verifiable certificate.
              </p>

              <div className="poster99-features">
                <span className="poster99-chip">✓ Verified Certificate</span>
                <span className="poster99-chip">✓ Real Projects</span>
                {/* <span className="poster99-chip">✓ Mentor Support</span> */}
                <span className="poster99-chip">✓ GitHub Portfolio</span>
              </div>

              <div className="poster99-urgency">⚡ Seats filling fast</div>

              <div className="poster99-cta-row">
                <Link to="/microinternships" className="poster99-cta">Start for ₹99 →</Link>
                <div className="poster99-social">
                  <div className="poster99-avatars">
                    <span className="poster99-avatar" style={{ background: '#FFD166' }}>A</span>
                    <span className="poster99-avatar" style={{ background: '#6EE7B7' }}>S</span>
                    <span className="poster99-avatar" style={{ background: '#93C5FD' }}>R</span>
                  </div>
                  <span className="poster99-social-text">200+ students enrolled</span>
                </div>
              </div>
            </div>

            {/* Price badge */}
            <div className="poster99-badge-wrap">
              <div className="poster99-badge-ring" />
              <div className="poster99-badge-ring-soft" />
              <div className="poster99-badge">
                <span className="poster99-badge-strike">₹399</span>
                <span className="poster99-badge-only">ONLY</span>
                <span className="poster99-badge-price">₹99</span>
                <span className="poster99-badge-sub">All Inclusive</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ STATS ═══════════════════════════════════════════ */}
      <section style={{ background: 'var(--bg2)', borderBottom: '1px solid var(--border)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)' }} className="stats-grid">
            {stats.map((s, i) => <StatItem key={i} {...s} last={i === stats.length - 1} />)}
          </div>
        </div>
      </section>

      {/* ══ HOW IT WORKS ════════════════════════════════════ */}
      <section style={{ padding: '120px 0', background: 'var(--bg)', position: 'relative', overflow: 'hidden' }}>
        <CircuitBg />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: 60 }}>
            <div className="section-label">PROCESS</div>
            <h2 style={{ fontSize: 'clamp(30px,4vw,52px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 12 }}>
              From Zero to{' '}
              <span style={{ background: `linear-gradient(135deg,${V1},${V2})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Certified</span>
            </h2>
            <p style={{ color: 'var(--muted)', fontSize: 16, maxWidth: 400, margin: '0 auto' }}>Four steps — no confusion, no hidden requirements</p>
          </div>

          {/* Step tab bar */}
          <div style={{ display: 'flex', borderRadius: 14, overflow: 'hidden', border: '1px solid var(--border)', marginBottom: 48 }}>
            {steps.map((s, i) => (
              <button key={i} onClick={() => setActiveStep(i)} style={{
                flex: 1, padding: '15px 10px', border: 'none', cursor: 'pointer',
                background: i === activeStep ? V3 : 'var(--bg2)',
                borderRight: i < steps.length - 1 ? '1px solid var(--border)' : 'none',
                transition: 'background 0.25s',
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5,
              }}>
                <span style={{ fontFamily: "'Inter',sans-serif", fontWeight: 900, fontSize: 10, color: i === activeStep ? V2 : 'var(--muted)', letterSpacing: '0.08em' }}>{s.num}</span>
                <span style={{ fontWeight: 700, fontSize: 13, color: i === activeStep ? '#fff' : 'var(--muted)' }}>{s.title}</span>
              </button>
            ))}
          </div>

          {/* Active step */}
          {steps.map((s, i) => (
            <div key={i} style={{
              display: i === activeStep ? 'grid' : 'none',
              gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center',
              animation: 'fadeSlideIn 0.4s ease both',
            }} className="step-detail-grid">
              {/* Image with diagonal clip */}
              <div style={{
                borderRadius: 20, overflow: 'hidden',
                clipPath: 'polygon(0 0, 100% 0, 100% 92%, 94% 100%, 0 100%)',
                aspectRatio: '16/11',
                boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
              }}>
                <img src={s.img} alt={s.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              {/* Text */}
              <div>
                <div style={{
                  fontFamily: "'Inter',sans-serif", fontWeight: 900,
                  fontSize: 'clamp(72px,10vw,120px)', lineHeight: 1,
                  color: `${V1}18`, letterSpacing: '-0.05em', marginBottom: 8,
                }}>{s.num}</div>
                <h3 style={{ fontSize: 'clamp(24px,3vw,36px)', fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 16, marginTop: -20 }}>{s.title}</h3>
                <p style={{ color: 'var(--text-2)', fontSize: 16.5, lineHeight: 1.8, maxWidth: 380 }}>{s.desc}</p>
                <div style={{ display: 'flex', gap: 8, marginTop: 28 }}>
                  {steps.map((_, j) => (
                    <div key={j} onClick={() => setActiveStep(j)} style={{
                      width: j === activeStep ? 24 : 8, height: 8, borderRadius: 99, cursor: 'pointer',
                      background: j === activeStep ? `linear-gradient(90deg,${V1},${V2})` : 'var(--border-strong)',
                      transition: 'all 0.3s',
                    }} />
                  ))}
                </div>
                <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                  {activeStep > 0 && <button onClick={() => setActiveStep(a => a - 1)} style={{ padding: '10px 22px', borderRadius: 9, border: '1px solid var(--border-strong)', background: 'transparent', color: 'var(--text)', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>← Prev</button>}
                  {activeStep < steps.length - 1 && <button onClick={() => setActiveStep(a => a + 1)} style={{ padding: '10px 22px', borderRadius: 9, border: 'none', background: `linear-gradient(135deg,${V1},${V3})`, color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>Next →</button>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ══ COURSES CAROUSEL ════════════════════════════════ */}
      <section style={{ padding: '120px 0', background: 'var(--bg2)', position: 'relative', overflow: 'hidden' }}>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <FeaturedCoursesSection apiCourses={apiCourses} loading={coursesLoading} />
        </div>
      </section>

      {/* ══ WHY THIRANX — image feature cards ══════════════ */}
      <section style={{ padding: '120px 0', background: 'var(--bg)', position: 'relative', overflow: 'hidden' }}>
        <CircuitBg />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 80, alignItems: 'start' }} className="why-grid">
            {/* Sticky left */}
            <div className="why-sticky" style={{ position: 'sticky', top: 120 }}>
              <div className="section-label">WHY THIRANX</div>
              <h2 style={{ fontSize: 'clamp(28px,3.5vw,48px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 20 }}>
                Because Degrees<br />
                <span style={{ background: `linear-gradient(135deg,${V1},${V2})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Aren't Enough</span>
              </h2>
              <p style={{ color: 'var(--muted)', fontSize: 16, lineHeight: 1.75, maxWidth: 320 }}>
                We fill the gap between what college teaches and what companies actually hire for.
              </p>
              <Link to="/courses" className="btn btn-primary" style={{ marginTop: 36 }}>Start Learning</Link>
            </div>

            {/* Feature cards with image */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {features.map((f, i) => (
                <div key={i} className="card" style={{ padding: 0, overflow: 'hidden', display: 'grid', gridTemplateColumns: '130px 1fr', minHeight: 108 }}>
                  <div style={{ overflow: 'hidden', position: 'relative', flexShrink: 0 }}>
                    <img src={f.img} alt={f.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }}
                      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.08)'}
                      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    />
                    {/* Diagonal edge cut */}
                    <div style={{
                      position: 'absolute', top: 0, right: -1, bottom: 0, width: 30,
                      background: 'var(--card, var(--bg3))',
                      clipPath: 'polygon(100% 0, 100% 100%, 0 100%)',
                    }} />
                  </div>
                  <div style={{ padding: '18px 20px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                      <div style={{ width: 3, height: 18, borderRadius: 99, background: `linear-gradient(to bottom,${V1},${V2})`, flexShrink: 0 }} />
                      <h3 style={{ fontSize: 16, fontWeight: 800, letterSpacing: '-0.01em' }}>{f.title}</h3>
                    </div>
                    <p style={{ color: 'var(--muted)', fontSize: 13.5, lineHeight: 1.65 }}>{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══ TESTIMONIALS — auto-switch carousel (Hidden for now) ══════════════
      <section
        style={{ padding:'120px 0', background:'var(--bg2)', overflow:'hidden' }}
        onMouseEnter={() => { testiPausedRef.current = true; }}
        onMouseLeave={() => { testiPausedRef.current = false; }}
      >
        <div className="container">
          {/* Header row * /}
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:56, flexWrap:'wrap', gap:16 }}>
            <div>
              <div className="section-label">ALUMNI</div>
              <h2 style={{ fontSize:'clamp(28px,4vw,50px)', fontWeight:800, letterSpacing:'-0.025em' }}>
                What Our Students{' '}
                <span style={{ background:`linear-gradient(135deg,${V1},${V2})`, WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text' }}>Say</span>
              </h2>
              <p style={{ color:'var(--muted)', fontSize:14, marginTop:8 }}>
                {testiIdx + 1} of {testimonials.length} — auto-switching
              </p>
            </div>
            {/* Prev / Next buttons * /}
            <div style={{ display:'flex', gap:10 }}>
              {[{fn:prevTesti, pts:'15 18 9 12 15 6'}, {fn:nextTesti, pts:'9 18 15 12 9 6'}].map(({fn,pts},i) => (
                <button key={i} onClick={fn} style={{
                  width:46, height:46, borderRadius:'50%',
                  background:'var(--bg3)', border:'1.5px solid var(--border-strong)',
                  color:'var(--text)', cursor:'pointer',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  transition:'all 0.2s',
                }}
                  onMouseEnter={e => { e.currentTarget.style.background=V1; e.currentTarget.style.borderColor=V1; e.currentTarget.style.color='#fff'; }}
                  onMouseLeave={e => { e.currentTarget.style.background='var(--bg3)'; e.currentTarget.style.borderColor='var(--border-strong)'; e.currentTarget.style.color='var(--text)'; }}
                >
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points={pts} />
                  </svg>
                </button>
              ))}
            </div>
          </div>

          {/* Sliding track * /}
          <div style={{ position:'relative', overflow:'hidden' }}>
            <div style={{
              display:'flex', gap:20,
              transition:'transform 0.55s cubic-bezier(0.34,1.1,0.64,1)',
              transform:`translateX(calc(${-testiIdx * (360 + 20)}px + 50% - 180px))`,
              willChange:'transform',
            }}>
              {testimonials.map((t,i) => {
                const isActive = i === testiIdx;
                return (
                  <div key={i} onClick={() => setTestiIdx(i)} style={{
                    flexShrink:0, width:360,
                    background:'var(--bg)', borderRadius:20, overflow:'hidden',
                    border:`1px solid ${isActive ? `${V1}55` : 'var(--border)'}`,
                    boxShadow: isActive ? `0 20px 60px rgba(0,0,0,0.22), 0 0 0 1px ${V1}33` : '0 4px 20px rgba(0,0,0,0.08)',
                    transform: isActive ? 'scale(1)' : 'scale(0.93)',
                    opacity: isActive ? 1 : 0.55,
                    transition:'all 0.45s cubic-bezier(0.34,1.1,0.64,1)',
                    cursor: isActive ? 'default' : 'pointer',
                  }}>
                    {/* Top strip + avatar * /}
                    <div style={{ position:'relative', height:70, background:`linear-gradient(135deg,${V4},${V3})` }}>
                      <div style={{ position:'absolute', bottom:-1, left:0, right:0, height:36, background:'var(--bg)', clipPath:'polygon(0 100%, 100% 0, 100% 100%)' }} />
                      <div style={{ position:'absolute', bottom:-22, left:22, width:52, height:52, borderRadius:'50%', overflow:'hidden', border:'3px solid var(--bg)', boxShadow:`0 0 0 2px ${V1}55` }}>
                        <img src={t.img} alt={t.name} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                      </div>
                    </div>

                    <div style={{ padding:'30px 22px 22px' }}>
                      <div style={{ fontWeight:800, fontSize:15, letterSpacing:'-0.01em', color:'var(--text)' }}>{t.name}</div>
                      <div style={{ color:V2, fontSize:12, fontWeight:700, marginTop:2, marginBottom:10 }}>{t.role} · {t.batch}</div>
                      <div style={{ display:'flex', gap:2, marginBottom:12 }}>
                        {[1,2,3,4,5].map(s => <span key={s} style={{ color:'#f5a623', fontSize:13 }}>★</span>)}
                      </div>
                      <p style={{ color:'var(--text-2)', fontSize:14, lineHeight:1.75, fontStyle:'italic' }}>"{t.text}"</p>
                    </div>
                  </div>
                );
              })}
            </div>
            {/* Edge fade * /}
            <div style={{ position:'absolute', top:0, left:0, bottom:0, width:100, background:'linear-gradient(to right,var(--bg2),transparent)', pointerEvents:'none', zIndex:2 }} />
            <div style={{ position:'absolute', top:0, right:0, bottom:0, width:100, background:'linear-gradient(to left,var(--bg2),transparent)', pointerEvents:'none', zIndex:2 }} />
          </div>

          {/* Dot indicators * /}
          <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:32 }}>
            {testimonials.map((_,i) => (
              <button key={i} onClick={() => setTestiIdx(i)} style={{
                width: i===testiIdx ? 28 : 8, height:8, borderRadius:99,
                border:'none', cursor:'pointer', padding:0,
                background: i===testiIdx ? `linear-gradient(90deg,${V1},${V2})` : 'var(--border-strong)',
                transition:'all 0.3s ease',
              }} />
            ))}
          </div>
        </div>
      </section>
      ════════════════════════════════════════════════════════  */}

      {/* ══ CTA ═════════════════════════════════════════════ */}
      <section style={{ padding: '80px 0 110px', background: 'var(--bg)' }}>
        <div className="container">
          <div style={{
            borderRadius: 28, overflow: 'hidden', position: 'relative',
            background: `linear-gradient(135deg,${V4} 0%,${V3} 50%,${V1} 100%)`,
            padding: 'clamp(60px,8vw,100px) clamp(32px,6vw,80px)',
            textAlign: 'center',
            clipPath: 'polygon(0 0, 100% 0, 100% 88%, 96% 100%, 0 100%)',
          }}>
            <div style={{
              position: 'absolute', inset: 0,
              backgroundImage: 'url(https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200&q=40)',
              backgroundSize: 'cover', backgroundPosition: 'center',
              opacity: 0.06, mixBlendMode: 'luminosity',
            }} />
            <CircuitBg />
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div className="section-label" style={{ background: 'rgba(255,255,255,0.10)', borderColor: 'rgba(255,255,255,0.18)', color: 'rgba(255,255,255,0.8)' }}>START TODAY</div>
              <h2 style={{ fontSize: 'clamp(34px,5vw,62px)', fontWeight: 900, color: '#fff', marginBottom: 18, letterSpacing: '-0.03em', fontFamily: "'Inter',sans-serif" }}>
                Ready to Build<br />Your Future?
              </h2>
              <p style={{ color: 'rgba(255,255,255,0.72)', fontSize: 17, maxWidth: 460, margin: '0 auto 48px', lineHeight: 1.78 }}>
                Join hundreds of students learning, growing, and getting certified with ThiranX across Tamil Nadu.
              </p>
              <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link to="/register" style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: '#ffffff', color: V1, padding: '16px 44px', borderRadius: 12,
                  fontWeight: 800, fontSize: 15,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
                  transition: 'all 0.22s cubic-bezier(.34,1.56,.64,1)',
                }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 16px 48px rgba(0,0,0,0.3)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.22)'; }}
                >Start Learning Today</Link>
                <Link to="/courses" style={{
                  display: 'inline-flex', alignItems: 'center',
                  background: 'rgba(255,255,255,0.10)', color: '#fff',
                  padding: '16px 36px', borderRadius: 12, fontWeight: 700, fontSize: 15,
                  border: '1.5px solid rgba(255,255,255,0.22)',
                  transition: 'all 0.2s',
                }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.18)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.10)'; }}
                >Browse Courses</Link>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', gap: 32, marginTop: 40, flexWrap: 'wrap' }}>
                {['Secure Payment', 'Verified Certificates', 'Modern Curriculum'].map((b, i) => (
                  <div key={i} style={{ color: 'rgba(255,255,255,0.55)', fontSize: 12.5, fontWeight: 700, letterSpacing: '0.04em', display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ width: 5, height: 5, borderRadius: '50%', background: V2, display: 'inline-block' }} />{b}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @keyframes pulseGlow    { 0%,100%{opacity:.4} 50%{opacity:1} }
        @keyframes floatY       { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
        @keyframes fadeSlideIn  { from{opacity:0;transform:translateX(16px)} to{opacity:1;transform:translateX(0)} }
        @keyframes scrollDot    { 0%,100%{transform:translateY(0);opacity:1} 50%{transform:translateY(12px);opacity:0.3} }
        @keyframes marqueeScroll{ from{transform:translateX(0)} to{transform:translateX(-50%)} }
        @keyframes progressBar  { from{width:0%} to{width:100%} }
        @media (max-width:960px) {
          .stats-grid        { grid-template-columns:repeat(2,1fr)!important; }
          .stats-grid>*:nth-child(2) { border-right:none!important; }
          .hero-grid         { grid-template-columns:1fr!important; }
          .hero-img-col      { display:none!important; }
          .why-grid          { grid-template-columns:1fr!important; }
          .why-sticky        { position:static!important; top:auto!important; }
          .step-detail-grid  { grid-template-columns:1fr!important; }
        }
        @media (max-width:480px) {
          .stats-grid { grid-template-columns:1fr 1fr!important; }
        }

        /* ══ ₹99 Poster ══════════════════════════════════════ */
        @keyframes posterShine   { 0%{left:-60%} 55%{left:130%} 100%{left:130%} }
        @keyframes badgeSpin     { to{transform:rotate(360deg)} }
        @keyframes badgePulse    {
          0%,100% { box-shadow:0 16px 50px rgba(0,0,0,0.4), 0 0 0 0 rgba(255,209,102,0.55); }
          50%     { box-shadow:0 16px 50px rgba(0,0,0,0.4), 0 0 0 16px rgba(255,209,102,0); }
        }

        .poster99-card {
          position: relative; border-radius: 28px; overflow: hidden;
          padding: clamp(40px,6vw,64px) clamp(28px,5vw,60px);
          display: flex; align-items: center; justify-content: space-between; gap: 40px; flex-wrap: wrap;
        }
        .poster99-glow { position: absolute; border-radius: 50%; filter: blur(80px); pointer-events: none; z-index: 0; }
        .poster99-glow-1 { top: -70px; left: -60px; width: 240px; height: 240px; background: var(--v2); opacity: 0.35; }
        .poster99-glow-2 { bottom: -90px; right: 18%; width: 280px; height: 280px; background: #FFD166; opacity: 0.18; }
        .poster99-shine {
          position: absolute; top: 0; left: -60%; width: 45%; height: 100%;
          background: linear-gradient(120deg, transparent, rgba(255,255,255,0.14), transparent);
          transform: skewX(-20deg); animation: posterShine 5.5s ease-in-out infinite; pointer-events: none; z-index: 1;
        }
        .poster99-tag {
          position: absolute; top: 22px; right: 22px; z-index: 3;
          background: linear-gradient(135deg,#FFD166,#FFB020); color: #3a0a66;
          font-weight: 800; font-size: 11px; letter-spacing: 0.06em;
          padding: 7px 14px; border-radius: 999px;
          box-shadow: 0 6px 18px rgba(255,176,32,0.4);
        }
        .poster99-content { position: relative; z-index: 2; max-width: 560px; }
        .poster99-title {
          font-size: clamp(28px,4vw,46px); font-weight: 900; color: #fff;
          margin: 14px 0 16px; letter-spacing: -0.02em; line-height: 1.15;
          font-family: 'Inter', sans-serif;
        }
        .poster99-price-inline { color: #FFD166; }
        .poster99-desc { color: rgba(255,255,255,0.78); font-size: 16px; line-height: 1.7; margin-bottom: 22px; max-width: 460px; }
        .poster99-features { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 18px; }
        .poster99-chip {
          background: rgba(255,255,255,0.12); border: 1px solid rgba(255,255,255,0.22); color: #fff;
          font-size: 12.5px; font-weight: 700; padding: 7px 14px; border-radius: 999px; white-space: nowrap;
        }
        .poster99-urgency { color: #FFD166; font-size: 13px; font-weight: 800; margin-bottom: 22px; }
        .poster99-cta-row { display: flex; align-items: center; gap: 22px; flex-wrap: wrap; }
        .poster99-cta {
          display: inline-flex; align-items: center; gap: 8px;
          background: #fff; color: #7F00FF; padding: 15px 36px; border-radius: 12px;
          font-weight: 800; font-size: 15px; box-shadow: 0 8px 32px rgba(0,0,0,0.25);
          transition: all 0.22s cubic-bezier(.34,1.56,.64,1); text-decoration: none;
        }
        .poster99-cta:hover { transform: translateY(-3px); box-shadow: 0 16px 48px rgba(0,0,0,0.3); }
        .poster99-social { display: flex; align-items: center; gap: 10px; }
        .poster99-avatars { display: flex; }
        .poster99-avatar {
          width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
          font-size: 12px; font-weight: 800; color: #2B0057; border: 2px solid rgba(255,255,255,0.35);
          margin-left: -9px;
        }
        .poster99-avatar:first-child { margin-left: 0; }
        .poster99-social-text { color: rgba(255,255,255,0.75); font-size: 12.5px; font-weight: 600; }

        .poster99-badge-wrap {
          position: relative; z-index: 2; width: 280px; height: 280px;
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
          filter: drop-shadow(0 18px 40px rgba(0,0,0,0.4));
          transform: translateX(-30px);
        }
        .poster99-badge-ring {
          position: absolute; inset: -26px; border-radius: 50%;
          background: repeating-conic-gradient(from 0deg, #FFD166 0deg 4deg, transparent 4deg 15deg);
          animation: badgeSpin 18s linear infinite;
        }
        .poster99-badge-ring-soft {
          position: absolute; inset: -10px; border-radius: 50%;
          background: rgba(255,209,102,0.25); filter: blur(8px);
        }
        .poster99-badge {
          position: relative; width: 240px; height: 240px; border-radius: 50%;
          background: linear-gradient(135deg,#FFE29A,#FFB020);
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          border: 5px solid #fff;
          animation: badgePulse 2.4s ease-in-out infinite;
        }
        .poster99-badge-strike { font-size: 16px; color: rgba(58,10,102,0.6); text-decoration: line-through; font-weight: 700; }
        .poster99-badge-only { font-size: 14px; font-weight: 800; color: #3a0a66; letter-spacing: 0.06em; margin: 2px 0; }
        .poster99-badge-price { font-size: 62px; font-weight: 900; color: #3a0a66; line-height: 1; font-family: 'Inter', sans-serif; }
        .poster99-badge-sub { font-size: 13px; font-weight: 700; color: #3a0a66; text-transform: uppercase; letter-spacing: 0.05em; margin-top: 5px; }

        @media (max-width:960px) {
          .poster99-card       { flex-direction: column; text-align: center; }
          .poster99-content    { max-width: 100%; }
          .poster99-features   { justify-content: center; }
          .poster99-urgency    { text-align: center; }
          .poster99-cta-row    { justify-content: center; }
          .poster99-badge-wrap { order: -1; transform: none; }
          .poster99-tag        { position: static; display: inline-block; margin-bottom: 16px; }
        }
        @media (max-width:480px) {
          .poster99-badge-wrap  { width: 220px; height: 220px; }
          .poster99-badge       { width: 188px; height: 188px; }
          .poster99-badge-price { font-size: 48px; }
        }
      `}</style>
    </div>
  );
};

export default Home;

// Home.jsx
// ────────────────────────────────────────────────────────────
// ThiranX — Home page, rewritten.
//  • Uses design-system classes (.btn, .card, .chip, .grad-text, .section-label)
//    instead of inline styles everywhere
//  • New hero: kinetic-type English/Tamil word swap with data panel
//  • New "How it works": visible 4-step timeline (not tabs)
//  • New courses section: ticker rail + grid (no coverflow)
//  • Live activity feed + batch card (real-time ed-tech energy)
//  • Accessibility: prefers-reduced-motion, :focus-visible (in CSS), aria-live feed
//  • No more duplicated keyframes; all motion defined in index.css
//  • Split into small, named sub-components in the same file for easy drop-in
// ────────────────────────────────────────────────────────────
